import { render, staticRenderFns } from "./ConfirmStudent.vue?vue&type=template&id=0c0c4b3b&scoped=true&"
import script from "./ConfirmStudent.vue?vue&type=script&lang=js&"
export * from "./ConfirmStudent.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStudent.vue?vue&type=style&index=0&id=0c0c4b3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c4b3b",
  null
  
)

export default component.exports